import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const pageMeta = {
  "/": {
    title: "The Dynamic Export Import LTD | Quality Elastic & Garment Accessories",
    description:
      "Leading Bangladesh manufacturer and global exporter of high-quality elastic tapes, webbing, ribbons, badges, and garment accessories since 2017.",
  },
  "/about": {
    title: "About Us | The Dynamic Export Import LTD",
    description:
      "Learn about The Dynamic Export Import LTD, our leadership, 5+ years of manufacturing experience, and partnerships with European, US, and Canadian buyers.",
  },
  "/products": {
    title: "Our Products | Elastic Tapes, Trims & Accessories | The Dynamic Exim",
    description:
      "Explore our wide range of premium elastic products, woven tapes, stretch webbing, drawcords, and custom garment trims.",
  },
  "/gallery": {
    title: "Factory Gallery | Manufacturing Facilities | The Dynamic Exim",
    description:
      "Take a look inside our high-speed needle loom manufacturing facility, production lines, and quality control operations in Dhaka, Bangladesh.",
  },
  "/contact": {
    title: "Contact Us | The Dynamic Export Import LTD",
    description:
      "Get in touch with The Dynamic Export Import LTD for bulk inquiries, custom elastic development, pricing, and export supply.",
  },
};

const PageMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = pageMeta[pathname] || pageMeta["/"];

    // Update document title
    document.title = meta.title;

    // Update or create meta description tag
    let metaDescriptionTag = document.querySelector('meta[name="description"]');
    if (!metaDescriptionTag) {
      metaDescriptionTag = document.createElement("meta");
      metaDescriptionTag.name = "description";
      document.head.appendChild(metaDescriptionTag);
    }
    metaDescriptionTag.setAttribute("content", meta.description);

    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default PageMeta;

